import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/index';
import { MessageService } from './message.service';
import { SessionService } from './session.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  toasterState = new Subject<any>();
  timer: number;
  timeout = environment.settings.toaster.timeout;

  constructor(
    private messageService: MessageService,
    private sessionService: SessionService
  ) {
    sessionService.logoutEvent.subscribe(() => {
      this.hideToaster();
    });

    // set default value
    this.timeout = this.timeout ? this.timeout : 5000;
  }

  showAlert(message: string) {
    this.showToaster(message, 'danger');
  }

  showInfo(message: string) {
    this.showToaster(message, 'warning');
  }

  showInfoTimed(message: string) {
    this.showToaster(message, 'warning');
    this.timer = window.setTimeout(() => {
      this.hideToaster();
    }, this.timeout);
  }

  showToaster(message: string, type: string) {
    this.messageService.postModalOpenMessage();
    this.toasterState.next({ show: true, message, type });
  }

  hideToaster() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    this.messageService.postModalCloseMessage();
    this.toasterState.next({ show: false });
  }
}
